import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    saveGroup,
    getAll,
    editData,
    getGroupsForDropdown
};

async function saveGroup(data){
    let group = {
        groupID: 0,
        groupCode: data.groupCode,
        groupName: data.groupName.trim(),
        isActive: data.isActive,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/Group/SaveGroup', null, group);
    return response;
}

async function getAll(){
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function editData(data) {
    data.groupName = data.groupName.trim();
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/Group/UpdateGroup', null, data);
    return response;
}

async function getGroupsForDropdown() {
    var groupArray = [];
    
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }

    return groupArray;
}
